import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { ExternalCommunication, ExternalCommunicationPayload } from 'icreate/common/models/external-communication';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ExternalCommunicationService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getList(fcuId: string) {
        return await lastValueFrom(
            this.http.get<ExternalCommunication[]>(`${this.domain}/api/externalCommunication`, {
                headers: this.headers,
                params: { fcuId },
            })
        );
    }

    async getListByVesselId(vesselId: string) {
        return await lastValueFrom(
            this.http.get<ExternalCommunication[]>(`${this.domain}/api/externalCommunication`, {
                headers: this.headers,
                params: { vesselId },
            })
        );
    }

    async create(externalCommunicationData: ExternalCommunicationPayload) {
        return await lastValueFrom(
            this.http.post<ExternalCommunication[]>(
                `${this.domain}/api/externalCommunication`,
                externalCommunicationData,
                {
                    headers: this.headers,
                }
            )
        );
    }

    async update(externalCommunicationData: ExternalCommunicationPayload) {
        return await lastValueFrom(
            this.http.put(
                `${this.domain}/api/externalCommunication/${externalCommunicationData.id}`,
                externalCommunicationData,
                {
                    headers: this.headers,
                }
            )
        );
    }

    async updatePorts(externalCommunicationData: ExternalCommunicationPayload[], shouldEmit) {
        return await lastValueFrom(
            this.http.put(
                `${this.domain}/api/externalCommunication/ports`,
                { externalCommunicationData, shouldEmit },
                {
                    headers: this.headers,
                }
            )
        );
    }

    async deleteExtComm(externalCommunicationDataId: string) {
        return await lastValueFrom(
            this.http.delete(`${this.domain}/api/externalCommunication/${externalCommunicationDataId}`)
        );
    }
}
